import { Card, CardContent } from "@/components/ui/card";
import { Progress } from "@/components/ui/progress";
import { TrendingUp, TrendingDown } from "lucide-react";
import { LucideIcon } from "lucide-react";

interface EnhancedStatCardProps {
  title: string;
  value: string | number;
  change?: {
    value: number;
    label: string;
  };
  icon?: LucideIcon;
  type?: "default" | "gauge";
  gaugeValue?: number;
  gaugeLabel?: string;
}

export function EnhancedStatCard({
  title,
  value,
  change,
  icon: Icon,
  type = "default",
  gaugeValue,
  gaugeLabel,
}: EnhancedStatCardProps) {
  const isPositive = change && change.value > 0;

  return (
    <Card className="hover:shadow-lg transition-shadow">
      <CardContent className="p-6">
        <div className="flex items-start justify-between mb-4">
          <div>
            <p className="text-sm text-muted-foreground mb-1">{title}</p>
            <p className="text-4xl font-bold text-foreground">{value}</p>
          </div>
          {Icon && (
            <div className="p-3 bg-primary/10 rounded-lg">
              <Icon className="h-6 w-6 text-primary" />
            </div>
          )}
        </div>

        {type === "gauge" && gaugeValue !== undefined && (
          <div className="space-y-2">
            <div className="flex items-center justify-between">
              <span className="text-sm font-medium text-success">{gaugeLabel}</span>
              <span className="text-sm font-bold text-foreground">{gaugeValue}%</span>
            </div>
            <Progress value={gaugeValue} className="h-2" />
          </div>
        )}

        {type === "default" && change && (
          <div className="flex items-center gap-2 mt-2">
            {isPositive ? (
              <TrendingUp className="h-4 w-4 text-success" />
            ) : (
              <TrendingDown className="h-4 w-4 text-destructive" />
            )}
            <span className={`text-sm font-medium ${isPositive ? "text-success" : "text-destructive"}`}>
              {isPositive ? "+" : ""}{change.value}
            </span>
            <span className="text-sm text-muted-foreground">{change.label}</span>
          </div>
        )}
      </CardContent>
    </Card>
  );
}
